import { render, staticRenderFns } from "./SAMPLE_RETURNED.vue?vue&type=template&id=647573f2"
import script from "./SAMPLE_RETURNED.vue?vue&type=script&lang=js"
export * from "./SAMPLE_RETURNED.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports